/**
 * This component was generated from a script. DO NOT MODIFY THIS FILE or your
 * changes will be overridden the next time icon components are generated. to
 * make persistent changes, modify the icon-template.hbs file and re run the
 * "npm run generate-icons" script
 */

import { Icon, IconProps } from '../Icon.component';

export const ClockIconSmall: React.FC<React.PropsWithChildren<IconProps>> = (props) => (
  <Icon size={16} {...props} viewBox='0 0 8 8'>
    <path
      fillRule='evenodd'
      d='M1.19999 3.99998C1.19999 2.4536 2.4536 1.19999 3.99998 1.19999C5.54638 1.19999 6.79997 2.4536 6.79997 3.99998C6.79997 5.54638 5.54638 6.79997 3.99998 6.79997C2.4536 6.79997 1.19999 5.54638 1.19999 3.99998ZM3.99998 0C1.79085 0 0 1.79086 0 3.99998C0 6.20912 1.79085 7.99995 3.99998 7.99995C6.20912 7.99995 8 6.20912 8 3.99998C8 1.79086 6.20912 0 3.99998 0ZM4.23807 3.00585C4.23807 2.67448 3.96945 2.40585 3.63807 2.40585C3.3067 2.40585 3.03807 2.67448 3.03807 3.00585V4.22626C3.03807 4.56545 3.25197 4.86776 3.57182 4.98065L4.62569 5.35261C4.93817 5.4629 5.28089 5.29899 5.39118 4.98651C5.50146 4.67403 5.33755 4.33131 5.02507 4.22102L4.23807 3.94326V3.00585Z'
    />
  </Icon>
);
